<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
       :loading="!flagNav"
        transition="scale-transition"
        max-height="64" 
        type="table-heading"
        >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('groupReplaceText') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row style="margin-bottom: 0rem;">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="ml-6 pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="textgroup-field-search-groupreplacetext"
                      :label="'Text Group'"
                      v-model="searchName"
                      @keydown.enter="Search"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-folder-search-outline"
                      hide-details
                      clearable
                      color="primary"
                    />
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end" style="display: flex; align-items: center;">
              <v-btn
                v-if="permissions.add"
                id="button-add-groupreplacetext"
                color="primary"
                class="control-btn create-btn mr-10"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Add()"
              >
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table-server
            class="modern-table"
            v-model:options="options"
            :items-per-page="options.itemsPerPage"
            :items-length="searchTotalTable"
            :items="menus"
            :headers="headers"
            :loading="loading"
            >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.number }}</td>
                <td>{{ item.name }}</td>
                <td style="text-align: center">
                  {{ substring(item.countReplaceText) }} 
                </td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center;">
                    <!-- Edit -->
                    <v-btn
                      v-if="permissions.edit || permissions.view"
                      id="button-edit-groupreplacement"
                      variant="text"
                      density="comfortable"
                      @click="Edit(item)"
                      class="action-btn edit-btn"
                      icon
                    >
                      <v-icon size="18">{{ isViewOnly ? 'mdi-eye-outline' : 'mdi-pencil-outline' }}</v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ isViewOnly ? 'View' : 'Edit' }}
                      </v-tooltip>
                    </v-btn>
                    <!-- Custom Divider -->
                    <div v-if="permissions.edit && permissions.delete" class="action-divider"></div>

                    <!-- Delete -->
                    <v-btn
                      v-if="permissions.delete"
                      id="button-delete-groupreplacement"
                      variant="text"
                      density="comfortable"
                      @click="DeleteGroup(item.groupReplaceID)"
                      class="action-btn delete-btn"
                      icon
                    >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </v-flex>
      </v-card>
    </v-container>
    <!-- Loading Please Wait... -->
    <!-- <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay> -->
    <!-- Edit -->
    <v-dialog v-model="Editdialog" max-width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t('edit') }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field id="textfield" :label="$t('groupModelName')" v-model="GroupModel.Name" :rules="[rules.required]" required outlined></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                :label="$t('model')"
                v-model="GroupModel.Model"
                :items="DDGPTModel"
                item-text="name"
                item-value="modelDisplayID"
                chips
                clearable
                deletable-chips
                multiple
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Editdialog = false">{{ $t('close') }}</v-btn>
          <v-btn v-if="!isViewOnly" color="blue darken-1" text @click="Save()">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add -->
    <v-dialog v-model="Adddialog" max-width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2" style="position: sticky; top: 0px">
          {{ $t('add') }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field id="textfield" :label="$t('groupModelName')" v-model="GroupModel.Name" :rules="[rules.required]" required outlined></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                :label="$t('model')"
                v-model="GroupModel.Model"
                :items="DDGPTModel"
                item-text="name"
                item-value="modelDisplayID"
                chips
                clearable
                deletable-chips
                multiple
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Adddialog = false">{{ $t('close') }}</v-btn>
          <v-btn v-if="!isViewOnly" color="blue darken-1" text @click="Save()">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- loading -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
export default {
  name: 'GroupReplacetext',
  mixins: [checkPermissionTwo],
  inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
  data: () => ({
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    today: null,

    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {},
    rules: {
      required: (value) => !!value || 'Required.',
    },
    DDGPTModel: [],
    headers_version_history: [],

    searchName: '',
    isSearch: false,
    isFirst: true,
    menus: [],
    GroupModel: {
      GroupID: null,
      Name: null,
      Model: null,
      NameModel: null,
    },
    sortBy: [],
    sortDesc :[],
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('GroupReplacetext');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('GroupReplacetext'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('GroupReplacetext'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('GroupReplacetext'),
        view: this.isViewOnly,
      }
    },
    headers() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false, width: '95px' },
        { title: 'Text Group', align: 'left', sortable: true ,value:'Name'},
        { title: this.$t('totalNumber'), align: 'center', sortable: true ,value:'Count'},
        { title: 'Action', align: 'center', sortable: false, width: '220px' },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.GetDefault();
    },
    Get() {
      let self = this;
      // self.dialog = true;
      self.loading = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      self.$call.GetTableGroupReplaceText(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          // self.dialog = false;
          self.loading = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          // self.dialog = false;
          self.loading = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { itemsPerPage } = self.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: null,
        sortBy: null
      };
      self.$call.GetTableGroupReplaceText(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(id) {
      let self = this;
      self.$swal
        .fire({
          title: this.$t('confirmDeletion'),
          text: this.$t('confirmDeletionGroup'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            self.$call.DeleteGroupReplaceText(
              id,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  self.dialog = false;
                  self.$swal.fire({
                    icon: 'success',
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.Get();
                }
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                console.error(errorResource);
              }
            );
          }
        });
    },
    Add() {
      let self = this;
      self.$router.push({
        name: 'ReplaceText',
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: 'ReplaceText',
        query: {
          id: item.groupReplaceID,
          name: item.name,
        },
      });
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    substring(text) {
      if (text.length > 50) {
        return text.substring(0, 50) + '...';
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
